import { StatusPill } from "../components/StatusPill";
import { SectionHeader } from "../components/SectionHeader";
import { fetchDashboardRisk } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";
import { formatRelative } from "../lib/format";

export function RiskControlsPage() {
  const state = useDashboardQuery(fetchDashboardRisk);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Risk controls</h1>
          <p>Tenant safety gates and risk policies. Live execution remains off unless config says otherwise.</p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="No risk policies"
        emptyDetail="Safety flags still apply. Policy rows appear when configured for this tenant."
      >
        {(data) => (
          <>
            <div className="card-grid">
              {data.controls.map((c) => (
                <article className="entity-card" key={c.name}>
                  <h3>{c.name}</h3>
                  <StatusPill label={c.value} tone={c.tone} />
                </article>
              ))}
            </div>
            {!data.emptyPolicies ? (
              <div className="panel" style={{ marginTop: 16 }}>
                <SectionHeader title="Policies" subtitle={`${data.policies.length} configured`} />
                <div className="panel-body">
                  <ul style={{ margin: 0, paddingLeft: 18, color: "var(--text-secondary)" }}>
                    {data.policies.map((p) => (
                      <li key={p.policyId}>
                        <strong>{p.name}</strong> · {p.status} · updated {formatRelative(p.updatedAt)}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
          </>
        )}
      </DashboardStateView>
    </>
  );
}
